<template>   
    <div>
      <v-card flat>      
          <div>
            <v-row no-gutters fill-height>
              <v-expansion-panels
                v-model="panel"
                :disabled="disabled"
                multiple 
                accordion     
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>Select Condition
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <!-- =============Start Search Condition============= -->
                        <v-row dense class="ma-0">
                          <!-- Welding Kind -->
                          <v-col
                            class="mt-2"
                            cols="6"
                            sm="6"
                            md="4"
                          >                           
                           <v-select 
                                label="Welding Kind"
                                v-model="wkind" 
                                :items="weldingKindList" 
                                return-object 
                                item-value="wkind" 
                                outlined
                                dense
                                @change = "selectItem"
                              >
                              </v-select>
                          </v-col>
                          <!-- Welding Process -->
                          <v-col                            
                            class="mt-2"
                            cols="6"
                            sm="6"
                            md="4"
                          >
                              <v-select 
                                label="Welding Process"
                                v-model="wtype" 
                                :items="weldingTypeList" 
                                return-object 
                                item-value="wtype" 
                                outlined
                                dense
                                @change = "selectItem"
                              >
                              </v-select>
                          </v-col>
                          <!-- Base Metal -->
                          <v-col
                            class="mt-2"
                            cols="6"
                            sm="6"
                            md="4"
                          >
                              <v-select 
                                label="Base Metal"
                                v-model="bm" 
                                :items="baseMetalList" 
                                item-value="bm" 
                                return-object 
                                outlined 
                                dense
                              >
                              </v-select>
                          </v-col>
                          <!-- File Metal -->
                          <v-col                            
                            class="mt-2"
                            cols="6"
                            sm="6"
                            md="4"
                          >
                              <v-select 
                                label="File Metal"
                                v-model="fm" 
                                :items="fileMetalList" 
                                return-object 
                                item-value="fm" 
                                outlined
                                dense
                              >
                              </v-select>
                          </v-col>
                          <!-- Group -->
                          <v-col                            
                            class="mt-2"
                            cols="6"
                            sm="6"
                            md="4"
                          >
                              <v-select 
                                label="Group"
                                v-model="grpName" 
                                :items="wkGroupList" 
                                return-object 
                                item-value="grpName" 
                                outlined
                                dense
                              >
                              </v-select>
                          </v-col>
                        </v-row>
                      <!-- ==========End Search Condition================= -->
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </div>
           <!-- v-show="!isMobileDevice"  /* CHỈ HIỂN THỊ KHI KHÔNG PHẢI MOBILE */ -->
          <v-fab-transition>
            <v-btn
              v-show="!isMobileDevice" 
              @click="btnRetrieve"
              absolute
              top
              right
              fab
            >
              <v-icon color="success">mdi-magnify</v-icon>
            </v-btn>
          </v-fab-transition>
      </v-card> 
      
      <v-card class="mt-2">  
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" fab small @click="exportToExcel" class="ml-2">
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </v-card-title>  
            <div class="ml-2">Count List: {{ gridMainList.length }}</div>
            <v-data-table
              :mobile-breakpoint="800"              
              :items-per-page="20"
              :headers="headers"
              :items="gridMainList"
              fixed-header
              :height="isMobileDevice ? undefined : 600"
              :search="search"
              dense
              :sort-by="[]"
              :sort-desc="[false]"
              :dark="dark"
              class="mobile-clean-table"
              style="max-width: 100%; overflow-x: auto;"
            >
              <template v-slot:item="{ item, isMobile }">
    
                <mobile-card-item
                    v-if="isMobile"
                    :item="item"
                    :header-value="item.rno"
                    :active="selectedRowIndex === item.rno"
                    :fields="mobileFields"
                    @click="showDetail(item)"    
                    @preview="previewImage"                
                    >

                   <template v-slot:wpsno="{ value }">
                    <div class="d-flex align-center justify-end">
                      <v-icon 
                        v-if="item.wpsFile" 
                        small 
                        color="red" 
                        class="mr-1 "
                        @click.stop="openPdf(item.wpsFile, `WPS_${item.wpsno}`)"
                      >
                        mdi-paperclip
                      </v-icon>
                      <span>{{ value }}</span>
                    </div>
                  </template>

                  <template v-slot:pqrno="{ value }">
                    <div class="d-flex align-center justify-end">
                      <v-icon 
                        v-if="item.pqrFile" 
                        small 
                        color="red" 
                        class="mr-1 "
                        @click.stop="openPdf(item.pqrFile, `PQR_${item.pqrno}`)"
                      >
                        mdi-paperclip
                      </v-icon>
                      <span>{{ value }}</span>
                    </div>
                  </template>

                   <template v-slot:approvdte>
                    <div class="d-flex justify-end mt-1">
                      <v-chip v-if="item.abs === 'RW'" x-small color="blue" dark class="mr-1">ABS</v-chip>
                      <v-chip v-if="item.nk === 'RW'" x-small color="green" dark class="mr-1">NK</v-chip>
                      <span class="ml-1">{{ item.approvdte }}</span>
                    </div>
                  </template>

                  <template v-slot:image>
                    <div v-if="item.imageContent" class="d-flex flex-column align-center w-full pa-2">
                      <div class="caption grey--text mb-1">Groove Design:</div>
                      <v-img 
                        :src="item.imageContent" 
                        max-width="250" 
                        contain 
                        class="grey lighten-4 rounded border shadow-sm"
                        @click.stop="previewImage(item.imageContent)"
                      ></v-img>
                    </div>
                  </template>
                </mobile-card-item>

                <tr v-else class="custom-pc-row">
                  <!-- <td class="text-center v-data-table__divider">
                    <v-chip :color="getColor(item.rno)" dark>{{ item.rno }}</v-chip>
                  </td> -->
                  <td class="v-data-table__divider">{{ item.rno }}</td>
                  <td class="v-data-table__divider">{{ item.div }}</td>
                  <td class="v-data-table__divider">{{ item.wkgrp }}</td>
                  <td class="v-data-table__divider">{{ item.wkind }}</td>
                  <td class="v-data-table__divider">{{ item.wtype }}</td>
                  <td class="v-data-table__divider">{{ item.contno }}</td>
                  <!-- <td class="v-data-table__divider">{{ item.wpsno }}</td>
                  <td class="v-data-table__divider">{{ item.pqrno }}</td> -->
                  <td class="v-data-table__divider">
                    <div class="d-flex align-center">
                      <v-icon 
                        v-if="item.wpsFile" 
                        small 
                        color="red" 
                        class="mr-1 pdf-icon-btn"
                        @click.stop="openPdf(item.wpsFile, `WPS_${item.wpsno}`)"
                      >
                        mdi-paperclip
                      </v-icon>
                      {{ item.wpsno }}
                    </div>
                  </td>

                  <td class="v-data-table__divider">
                    <div class="d-flex align-center">
                      <v-icon 
                        v-if="item.pqrFile" 
                        small 
                        color="red" 
                        class="mr-1 pdf-icon-btn"
                        @click.stop="openPdf(item.pqrFile, `PQR_${item.pqrno}`)"
                      >
                        mdi-paperclip
                      </v-icon>
                      {{ item.pqrno }}
                    </div>
                  </td>
                  <td class="v-data-table__divider">{{ item.bmfm }}</td>
                  <td class="v-data-table__divider">{{ item.testthick }}</td>
                  <td class="v-data-table__divider">{{ item.thickrange }}</td>
                  <td class="v-data-table__divider">{{ item.processseq }}</td>
                  <td class="v-data-table__divider">{{ item.wpos }}</td>
                  <td class="v-data-table__divider">{{ item.voltamp }}</td>
                  <td class="v-data-table__divider">{{ item.tsdia }}</td>
                  <td class="v-data-table__divider">{{ item.approvdte }}</td>
                  <td class="v-data-table__divider">{{ item.abs }}</td>
                  <td class="v-data-table__divider">{{ item.rina }}</td>
                  <td class="v-data-table__divider">{{ item.bv }}</td>
                  <td class="v-data-table__divider">{{ item.nk }}</td>
                  <td class="v-data-table__divider">{{ item.dnvgl }}</td>
                  <td class="v-data-table__divider">{{ item.lr }}</td>
                  <td class="v-data-table__divider">{{ item.kr }}</td>
                  <td class="v-data-table__divider" style="min-width: 120px;">
                    <v-img
                      v-if="item.imageContent"
                      :src="item.imageContent"
                      width="150"
                      height="60"
                      contain
                      class="rounded border ma-1 cursor-pointer"
                      @click="previewImage(item.imageContent)"
                    ></v-img>
                    <span v-else class="grey--text caption">No Image</span>
                  </td>
                  
                </tr>
              </template>
            </v-data-table> 
            <!-- v-dialog show Detail -->
            <v-dialog v-model="detailDialog" max-width="650px" scrollable>
                <v-card v-if="selectedItem">
                    <v-card-title class="headline grey lighten-2">
                    Detail Info (No. {{ selectedItem.rno }})
                    <v-spacer></v-spacer>
                    <v-btn icon @click="detailDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>

                    <v-card-text class="pa-4">
                    <div v-for="(field, i) in headers" :key="i" class="mb-3 border-bottom pb-1">
                        <div class="caption grey--text text-uppercase">{{ field.text }}</div>

                        <div class="subtitle-1 font-weight-medium black--text">
                          <template v-if="field.value === 'imageContent'">
                            <v-img 
                              v-if="selectedItem.imageContent"
                              :src="selectedItem.imageContent" 
                              max-width="100%" 
                              contain
                              class="grey lighten-4 rounded-lg mt-2"
                              @click="previewImage(selectedItem.imageContent)"
                            ></v-img>
                            <span v-else class="grey--text italic">No Image</span>
                          </template>
                          
                          <template v-else>
                            {{ selectedItem[field.value] || '-' }}
                          </template>
                        </div>
                    </div>
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="detailDialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>             
            <!-- v-dialog show Image -->
            <v-dialog v-model="imageDialog" max-width="800px" content-class="elevation-0">
              <v-card flat color="transparent" class="text-right">
                <v-btn icon dark @click="imageDialog = false" class="mb-2">
                  <v-icon large>mdi-close-circle</v-icon>
                </v-btn>
                
                <v-card-text class="pa-0">
                  <v-img
                    :src="selectedImageUrl"
                    width="100%"
                    contain
                    class="rounded-lg shadow-lg"
                    style="background-color: white;"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card-text>
                
                <div class="text-center mt-2">
                  <v-btn color="white" text @click="imageDialog = false">Close Escape</v-btn>
                </div>
              </v-card>
            </v-dialog>
      </v-card>

     <!-- Scroll To Top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab && isMobileDevice"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      style="z-index: 1000;"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
    </div>  
</template>

<script>
import  {
          mdiAccount,
          mdiPencil,
          mdiShareVariant,
          mdiDelete,
          mdiSelectSearch,
          mdiMapSearch 

        } from '@mdi/js'

import  {
          v80w1010List,
          getWeldingKind, 
          getWeldingProcess,
          getBaseMetal,
          getFileMetal,
          getWorkGroup,
        } from '@/api/view/tqm/80/v80w1010.js'

import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import { mobileTableMixin } from '@/mixins/mobileTableMixin.js' // Import mixin mới
import EventBus from '@/components/event-bus';
import {ftpDownloadViewer} from "@/api/view/tqm/common/common.js";

import {
  getDateFormat,
} from '@/utils/common.js'
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {
  name: "v80w1010",
  // Kế thừa cả 3: Base view, Grid và Mobile logic
  mixins: [baseview, BaseDataGrid, mobileTableMixin],
  data: () => ({   
    dark: false,
    isMobileDevice: false, // Biến mới
    imageDialog: false,     // Đóng/mở popup ảnh
    selectedImageUrl: '',   // Lưu URL ảnh đang được chọn để phóng to
    icons: {
      mdiAccount,
      mdiPencil,
      mdiShareVariant,
      mdiDelete,
      mdiSelectSearch,
      mdiMapSearch

    },    
    weldingKindList: [],
    wkind: '',
    weldingTypeList: [],
    wtype: '',
    baseMetalList: [],
    bm: '',
    fileMetalList: [],
    fm: '',

    wkGroupList: [],
    grpCd: '',
    grpName: '',

    panel: [0],
    disabled: false,
    hover: true,

    // data
    gridMainList: [],
    listSize: 0,
    
    mobile: false,
    search: '',
    headers: [
                {
                  text: 'No',
                  align: 'start',
                  value: 'rno',
                  divider: true,
                  sortable: false,
                  width: '30px'
                },
                { text: 'Division', sortable: false, align: 'center',value: 'div', width: '40px' },
                { text: 'Work Group', sortable: false, align: 'center',value: 'wkgrp', width: '80px' },
                { text: 'Welding Kind', sortable: false, align: 'center',value: 'wkind', width: '40px' },
                { text: 'Welding Process', sortable: false, align: 'center',value: 'wtype', width: '40px' },
                { text: 'Cont No', sortable: true, align: 'center',value: 'contno', width: '80px' },
                // { text: 'wpsFile', sortable: false, align: 'center',value: 'wpsFile', width: '80px' },
                { text: 'W.P.S No', sortable: false, align: 'center',value: 'wpsno', width: '150px' },
                // { text: 'pqrFile', sortable: false, align: 'center',value: 'pqrFile', width: '80px' },
                { text: 'PQR No', sortable: false, align: 'center',value: 'pqrno', width: '150px' },
                { text: 'B.M/F.M', sortable: false, align: 'center',value: 'bmfm', width: '250px' },
                { text: 'Test Thick(Dia)', sortable: false, align: 'center',value: 'testthick', width: '50px' },
                { text: 'Thick Range', sortable: false, align: 'center',value: 'thickrange', width: '50px' },
                { text: 'Process Sequence', sortable: true, align: 'center',value: 'processseq', width: '150px' },
                { text: 'W/Pos & Dirt', sortable: true, align: 'center',value: 'wpos', width: '50px' },
                { text: 'Volt/Amp', sortable: false, align: 'center',value: 'voltamp', width: '250px' },
                { text: 'T.Speed/W.C(Dia)', sortable: false, align: 'center',value: 'tsdia', width: '150px'},
                { text: 'Approve Date', sortable: false, align: 'center',value: 'approvdte', width: '50px'},
                { text: 'ABS', sortable: false, align: 'center',value: 'abs', width: '20px'},
                { text: 'RINA', sortable: false, align: 'center',value: 'rina', width: '20px'},
                { text: 'BV', sortable: false, align: 'center',value: 'bv', width: '20px'},
                { text: 'NK', sortable: false, align: 'center',value: 'nk', width: '20px'},
                { text: 'DNV', sortable: false, align: 'center',value: 'dnvgl', width: '20px'},
                { text: 'LR', sortable: false, align: 'center',value: 'lr', width: '20px'},
                { text: 'KR', sortable: false, align: 'center',value: 'kr', width: '20px'},
                { text: 'Join/Groove Design', sortable: false, align: 'center',value: 'imageContent', width: '150px'},
                
              ],
    selectedRowIndex: null, // Lưu index của dòng đang được chọn 
    // Chỉ cần khai báo list này là giao diện tự sinh ra
    mobileFields: [
      { label: 'Welding Kind', key: 'wkind' },
      { label: 'Welding Process', key: 'wtype' },
      { label: 'Cont No', key: 'contno' },
      // { label: 'wpsFile', key: 'wpsFile' },
      { label: 'W.P.S No', key: 'wpsno' },
      // { label: 'pqrFile', key: 'pqrFile' },
      { label: 'PQR No', key: 'pqrno' },
      { label: 'Base Metal', key: 'bm' },
      { label: 'File Metal', key: 'fm' },
      { label: 'Approve Date', key: 'approvdte' },
    ],       
  }),
  components: {
    DxDateBox,
    
  },

  computed: {
  },

  watch: {
   
  },
  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnRetrieve();
    });
  },
  mounted() {
    this.init()
    //Apply for Fab
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.loadColumnWidths(); // Khôi phục ngay khi load trang

    // Lắng nghe sự kiện thả chuột để lưu lại kích thước mới
    this.$el.querySelector('.v-data-table').addEventListener('mouseup', () => {
      // Đợi một chút để trình duyệt cập nhật xong style.width
      setTimeout(() => {
        this.saveColumnWidths();
      }, 100);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },
  methods: {   
  
    btnRetrieve() {
        this.gridMainList = []
        this.getMainList()
    },
    
    init() {
      this.getList()

    },
    //getList
    async getList() {
      try {
            this.openLoading('searching')
            let params1 = {
              shipNo: '',
            }
            let params2 = {
              deptCd: '',
            }

            await getWorkGroup(params1).then(res => {
                  this.wkGroupList.push('All')
                  res.list.forEach(e => {
                    this.wkGroupList.push(e.grpCd + ' : ' + e.wkgrp)
                  });
                  this.grpName = this.wkGroupList[0]
                })
            //getWeldingKind
            await getWeldingKind(params1).then(res => {
                  this.weldingKindList.push('All')
                  res.list.forEach(e => {
                    this.weldingKindList.push(e.divNm)
                  });
                  this.wkind = this.weldingKindList[0]
                })
            //getWeldingProcess    
            await getWeldingProcess(params1).then(res => {
                  this.weldingTypeList.push('All')
                  res.list.forEach(e => {                    
                    this.weldingTypeList.push(e.divNm)
                  });
                  this.wtype = this.weldingTypeList[0]
                })

          } finally {  
            this.selectItem()          
            this.endLoading()
          }

    },
    
    //get Group
    async selectItem(){
      this.baseMetalList = [];
      this.fileMetalList = [];

      let params = {
        wkind: this.wkind ==='All'?'':this.wkind,
        wtype: this.wtype ==='All'?'':this.wtype,
      }
      // console.log('params', params);
      
      await getBaseMetal(params).then(res => {
        // console.log('getBaseMetal', res.list.length);
        this.baseMetalList.push('All')
        res.list.forEach(e => {          
          this.baseMetalList.push(e.divNm)										
        });
        this.bm = this.baseMetalList[0]
      })

      await getFileMetal(params).then(res => {
        // console.log('getFileMetal', res.list.length);
        this.fileMetalList.push('All')
        res.list.forEach(e => {
          this.fileMetalList.push(e.divNm)										
        });
        this.fm = this.fileMetalList[0]
      })
    },   

    async getMainList() {
        try {
          this.openLoading('searching');

          // 1. Xử lý tham số tìm kiếm
          const grpCd = this.grpName ? this.grpName.split(' : ')[0] : 'All';
          
          const params = {
            wkind: this.wkind === 'All' ? '' : this.wkind,
            wtype: this.wtype === 'All' ? '' : this.wtype,
            bm: this.bm === 'All' ? '' : this.bm,
            fm: this.fm === 'All' ? '' : this.fm,
            respCd: grpCd === 'All' ? '' : grpCd,
          };

          if (this.wkind == 'All') {
            this.vToastify(this.$t('Sorry!, Select a welding kind!'), 'warn')
            return
          } 

          if (this.wtype == 'All') {
            this.vToastify(this.$t('Sorry!, Select a welding process!'), 'warn')
            return
          } 
          
          const res = await v80w1010List(params);

          // 2. Hàm Helper nội bộ để xử lý tải file (Tránh lặp code)
          const fetchFileBase64 = async (filePath) => {
            if (!filePath) return null;
            try {
              const parts = filePath.split('/');
              const fileNameWithExt = parts[parts.length - 1];
              const fnameParts = fileNameWithExt.split('.');
              const ext = fnameParts[fnameParts.length - 1].toLowerCase();
              const fname = fnameParts[0].replace(/ /g, "");

              const dataType = ext === 'pdf' 
                ? "data:application/pdf;base64," 
                : `data:image/${ext};base64,`;

              const fileRes = await ftpDownloadViewer(filePath, fname);
              return fileRes.body ? (dataType + fileRes.body) : null;
            } catch (err) {
              console.error(`Lỗi tải file: ${filePath}`, err);
              return null;
            }
          };

          // 3. Sử dụng Promise.all để chạy song song tất cả các bản ghi
          this.gridMainList = await Promise.all(res.list.map(async (e) => {
            // Chạy song song cả 3 yêu cầu tải file của mỗi dòng để tăng tốc độ
            const [imgContent, wpsPdf, pqrPdf] = await Promise.all([
              // fetchFileBase64(e.filename ? 'attachfile/QM/HVS_QM/Welding/' + e.filename : null),              
              fetchFileBase64(e.dsgimgpath),
              fetchFileBase64(e.wpsnofile),
              fetchFileBase64(e.pqrnofile)
            ]);

            return {
              ...e, // Giữ lại toàn bộ thuộc tính gốc
              imageContent: imgContent,
              wpsFile: wpsPdf,
              pqrFile: pqrPdf,
              bmfm: `${e.bm || ''} / ${e.fm || ''}`,
              voltamp: `${e.voltdirt || ''} / ${e.amp || ''}`,
              tsdia: `${e.tspeed || ''} / ${e.wcdia || ''}`
            };
          }));

          this.listSize = this.gridMainList.length;

          if (this.listSize > 0 && this.isMobileDevice) {
            this.panel = [];
          }

        } catch (error) {
          console.error("Lỗi getMainList:", error);
        } finally {
          this.endLoading();
        }
      },

    getColor (calories) {
        if (calories > 400) return 'red'
        else if (calories > 200) return 'orange'
        else return 'green'
    }, 
    //Xuất Exel file không có hình ảnh bằng thư viện xlsx
    exportToExcel() {
      if (this.gridMainList.length === 0) {
        alert("No data to export!");
        return;
      }

      try {
        this.openLoading('Exporting Excel...');

        // 1. Định nghĩa tiêu đề cột (Mapping từ key trong data sang tên tiếng Anh/Việt)
        const exportData = this.gridMainList.map(item => ({
          "No": item.rno,
          "Division": item.div,
          "Work group": item.wkgrp,
          "Welding Kind": item.wkind,
          "Welding process": item.wtype,
          "Cont No": item.contno,
          "WPS No": item.wpsno,
          "PQR No": item.pqrno,
          "B.M": item.bm,
          "F.M": item.fm,
          "Test Thick(Dia)": item.testthick,
          "Thick Range": item.thickrange,
          "Process Sequence": item.processseq,
          "W/Pos&Dirt": item.wpos,
          "Volt": item.voltdirt,
          "Amp.": item.amp,
          "T/Speed": item.tspeed,
          "W.C/Dia": item.wcdia,
          "Approve Date": item.approvdte,
          "ABS": item.abs,
          "RINA": item.rina,
          "BV": item.bv,
          "NK": item.nk,
          "DNV": item.dnvgl,
          "LR": item.lr,
          "KR": item.kr,
        }));

        // 2. Tạo WorkSheet từ dữ liệu đã map
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // 3. Tạo WorkBook (File Excel)
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "WPS_List");

        // 4. Xuất file với tên định dạng: Inspection_Date.xlsx
        const fileName = `WPS_List_${new Date().toISOString().slice(0,10)}.xlsx`;
        XLSX.writeFile(workbook, fileName);

      } catch (error) {
        console.error("Export Error:", error);
        alert("Export failed!");
      } finally {
        this.endLoading();
      }
    },
    //Xuất Exel file có hình ảnh bằng thư viện mạnh mẽ hơn là exceljs
    // async exportToExcel() {
    //   if (this.gridMainList.length === 0) {
    //     alert("No data to export!");
    //     return;
    //   }

    //   try {
    //     this.openLoading('Exporting Excel with Images...');
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet('WPS_List');

    //     // 1. Định nghĩa Columns (bao gồm cột Design cho hình ảnh)
    //     worksheet.columns = [
    //       { header: 'No', key: 'rno', width: 10 },
    //       { header: 'Division', key: 'div', width: 15 },
    //       { header: 'Welding Kind', key: 'wkind', width: 20 },
    //       { header: 'Design', key: 'design', width: 25 }, // Cột chứa ảnh
    //       { header: 'ABS', key: 'abs', width: 10 },
    //       { header: 'NK', key: 'nk', width: 10 },
    //       // Thêm các cột khác của bạn vào đây...
    //     ];

    //     // 2. Duyệt dữ liệu và chèn vào sheet
    //     for (let i = 0; i < this.gridMainList.length; i++) {
    //       const item = this.gridMainList[i];
    //       const rowNumber = i + 2; // +1 vì header là dòng 1, +1 vì index bắt đầu từ 0

    //       const row = worksheet.addRow({
    //         rno: item.rno,
    //         div: item.div,
    //         wkind: item.wkind,
    //         abs: item.abs,
    //         nk: item.nk
    //         // Map các field khác tương tự...
    //       });

    //       // Thiết lập chiều cao dòng để ảnh không bị quá nhỏ
    //       row.height = 80;

    //       // 3. Xử lý chèn hình ảnh (nếu có)
    //       if (item.imageContent && item.imageContent.includes('base64')) {
    //         try {
    //           const imageId = workbook.addImage({
    //             base64: item.imageContent,
    //             extension: 'png',
    //           });

    //           worksheet.addImage(imageId, {
    //             tl: { col: 3, row: i + 1 }, // col: 3 là cột 'Design' (0-indexed)
    //             ext: { width: 150, height: 100 },
    //             editAs: 'undefined'
    //           });
    //         } catch (imgErr) {
    //           console.error("Lỗi chèn ảnh tại dòng " + rowNumber, imgErr);
    //         }
    //       }
    //     }

    //     // 4. Xuất file
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const fileName = `WPS_List_${new Date().toISOString().slice(0,10)}.xlsx`;
    //     saveAs(new Blob([buffer]), fileName);

    //   } catch (error) {
    //     console.error("Export Error:", error);
    //     alert("Export failed!");
    //   } finally {
    //     this.endLoading();
    //   }
    // },
    
    // Hàm lưu độ rộng vào localStorage
    saveColumnWidths() {
      const widths = {};
      const ths = this.$el.querySelectorAll('.v-data-table th');
      
      ths.forEach((th, index) => {
        // Lưu theo index hoặc value của header để không bị lẫn
        widths[index] = th.style.width;
      });
      
      localStorage.setItem(`table_width_${this.$options.name}`, JSON.stringify(widths));
    },

    // Hàm khôi phục độ rộng khi vào lại trang
    loadColumnWidths() {
      const savedWidths = localStorage.getItem(`table_width_${this.$options.name}`);
      if (savedWidths) {
        const widths = JSON.parse(savedWidths);
        this.$nextTick(() => {
          const ths = this.$el.querySelectorAll('.v-data-table th');
          ths.forEach((th, index) => {
            if (widths[index]) {
              th.style.width = widths[index];
            }
          });
        });
      }
    },

    previewImage(url) {
      if (!url) return;
      this.selectedImageUrl = url;
      this.imageDialog = true;
    },

    /**
   * Hàm mở file PDF từ Base64 hoặc URL
   * @param {String} fileData: Chuỗi base64 hoặc đường dẫn URL
   * @param {String} fileName: Tên file muốn đặt (tùy chọn)
   */
  openPdf(fileData, fileName = 'document') {
    if (!fileData) {
      this.$toast?.error("Không có dữ liệu file!");
      return;
    }

    try {
      // Trường hợp dữ liệu là chuỗi Base64
      if (fileData.includes('base64') || fileData.length > 500) {
        const base64Content = fileData.includes(',') ? fileData.split(',')[1] : fileData;
        const byteCharacters = atob(base64Content);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(fileBlob);

        // Mở trong tab mới
        const newWindow = window.open(fileURL, '_blank');
        
        // Tự động thu hồi URL sau khi cửa sổ mới đã tải xong (khoảng 1 phút)
        setTimeout(() => URL.revokeObjectURL(fileURL), 60000);
        // Kiểm tra nếu trình duyệt chặn Pop-up
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          alert("Vui lòng cho phép trình duyệt mở Pop-up để xem file PDF.");
        }
      } 
      // Trường hợp dữ liệu là một đường dẫn URL trực tiếp
      else {
        window.open(fileData, '_blank');
      }
    } catch (error) {
      console.error("Lỗi khi mở PDF:", error);
      alert("Định dạng file không hợp lệ hoặc bị lỗi!");
    }
  }
  },

};
</script>
<style>
/* Import file CSS dùng chung cho toàn bộ Mobile Card */
/* Sử dụng dấu ~ trước @ để Webpack nhận diện đúng alias */
@import "~@/assets/css/mobile-table.css";

/* Các CSS tùy chỉnh khác cho menu này */
.border-bottom {
  border-bottom: 1px dashed #eee;
}
.v-card__text {
  max-height: 70vh; /* Giới hạn chiều cao popup trên mobile */
}

.custom-pc-row td .v-image__image {
  background-size: contain !important; /* Đảm bảo ảnh vẽ kỹ thuật luôn thấy hết chi tiết */
}

/* Trong mobile-table.css hoặc style của v80w1010.vue */
.cursor-pointer {
  cursor: zoom-in !important; /* Đổi icon chuột thành hình kính lúp */
  transition: opacity 0.3s;
}

.cursor-pointer:hover {
  opacity: 0.8; /* Hiệu ứng mờ nhẹ khi di chuột qua */
}

/* Hiệu ứng cho icon kẹp giấy */
.pdf-icon-btn {
  transition: all 0.2s ease-in-out; /* Giúp hiệu ứng mượt mà hơn */
  cursor: pointer;
}

/* Khi di chuột vào trên PC */
.pdf-icon-btn:hover {
  transform: scale(2); /* Phóng to 30% */
  color: #d32f2f !important; /* Đổi sang màu đỏ đậm hơn (v-red-darken-2) */
  filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.2)); /* Thêm bóng đổ nhẹ */
}

/* Hiệu ứng khi nhấn vào (Active) */
.pdf-icon-btn:active {
  transform: scale(1.1);
  opacity: 0.7;
}
</style>


